import { Sizes } from 'react-sizes';

export function isDesktop({ width }: Sizes) {
    return width > 1024;
}

export function mapSizesToProps(sizes: Sizes) {
    return {
        isDesktop: isDesktop(sizes)
    };
}
